import React from 'react';
import { getFirstAppliedFilter } from '@store/common/selectors';
import { useSelector } from 'react-redux';
import { FilterNameText, StyledFilterTag, VerticalBar } from './styled';

function PrimaryFilterTag() {
  const filter = useSelector(getFirstAppliedFilter);
  return (
    <div style={{ marginBottom: 10 }}>
      <StyledFilterTag
        key={`${filter.name}`}
        highlight={'#f6f6f6'}
        closable={false}
        style={{ fontSize: 24 }}
      >
        <VerticalBar color={'#0F93F5'} />
        <FilterNameText>
          {filter.name}
        </FilterNameText>
      </StyledFilterTag>
    </div>
  )
}

export default PrimaryFilterTag;
